import { useEffect, useState } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { getNewsInner } from "../Service/Api";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const News = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [yearRanges, setYearRanges] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [limit] = useState(100000);
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setSelectedYear(currentYear.toString());
  }, []);

  useEffect(() => {
    const fetchData = async (page = currentPage, year = selectedYear) => {
      try {
        const galleryData = await getNewsInner({
          page,
          limit,
          year: year === "All" ? "" : year,
        });

        const newsArray = galleryData.data || [];
        setData(newsArray);

        // Build years only once (or from all pages)
        if (newsArray.length && yearRanges.length === 0) {
          const uniqueYears = Array.from(
            new Set(
              newsArray.map((item) => new Date(item.fromDate).getFullYear())
            )
          ).sort((a, b) => b - a);
          setYearRanges(uniqueYears.map(String));
        }

        setTotalPages(galleryData.totalPages || 1);
        setCurrentPage(galleryData.currentPage || 1);
        setTotalCount(newsArray.length);
      } catch (err) {
        console.error("❌ Fetch Error:", err);
      }
    };

    fetchData();
  }, [selectedYear, currentPage]);

  useEffect(() => {
    let filteredData = data;

    if (selectedYear !== "All") {
      filteredData = filteredData.filter((item) => {
        if (item.fromDate) {
          const year = new Date(item.fromDate).getFullYear();
          return parseInt(selectedYear) === year;
        }
        return false;
      });
    }

    // Sort the filteredData by month in descending order
    filteredData.sort((a, b) => {
      const dateA = new Date(a.fromDate);
      const dateB = new Date(b.fromDate);
      return dateB - dateA;
    });

    setFilteredData(filteredData);
  }, [selectedYear, data]);
  const emptyArray = [
    {
      title: "News Title",
      description: "Stay Tunned For More Updates",
      day: "DD",
      month: "MM",
    },
  ];
  const handleModal = (id) => {
    navigate(`/newsInner?id=${id}`);
  };
  const homeMenu = [
    { label: "Latest Update", link: "/news" },
    { label: "Testimonials", link: "/testimonial" },
    { label: "School Calendar", link: "/calender" },
    { label: "CBSE Circulars", link: "/circular" },
    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },
    { label: "Fortnightly School Magazine", link: "/fortnightlyMagazine" },
    { label: "Carpe Diem'22", link: "/carpediem" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-latest-update.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Latest Updates"
                breadEnd="News"
                breadMid="Latest Updates"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xxl-12">
              <div className="month-selection float-end">
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="yearSelection">
                  <option value="All">All</option>
                  {yearRanges.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <ul className="admission-list news-list latest-update">
            {filterData.length > 0
              ? filterData.map((item, index) => {
                  return (
                    <li className="cursor-pointer" key={index}>
                      {" "}
                      <a onClick={() => navigate(`/newsInner?id=${item._id}`)}>
                        {item.title}
                      </a>
                    </li>
                  );
                })
              : emptyArray.map((item, index) => (
                  <li>
                    {" "}
                    <a>Stay Tuned For More Updates</a>
                  </li>
                ))}
          </ul>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default News;
